/**
 * WA: Ignored objects must always remain unchecked.
 * Because `tabular-grid` selects all rows when the checkbox column is toggled,
 * we need to manually unselect the ignored IDs.
 *
 * @param ignoredIds - Row IDs that must never be selected.
 * @param tabularGridRef - Reference to the tabular-grid instance.
 *
 * TODO: Use the tabular grid render once available, and hopefully do not
 * add a checkbox to the ignored objects rows.
 */
const uncheckIgnoredObjects = async (
  ignoredIds: string[],
  tabularGridRef: HTMLChTabularGridElement
) => {
  for (const ignoredId of ignoredIds) {
    await tabularGridRef.markRow(ignoredId, false);
  }
};

export default uncheckIgnoredObjects;
